import { useTranslation } from 'react-i18next';

import { HOSTING_TYPES_WITHOUT_SERVER_IMAGE_TOOLTIP } from '~/utils/hosting/constants';

import RenderCard from './RenderCard';

interface OperatingSystemProps {
  os: string;
  accountType?: string | null;
}

const OperatingSystem = ({ os, accountType = null }: OperatingSystemProps) => {
  const { t } = useTranslation('hosting', { keyPrefix: 'hostingNova' });
  const canShowServerImageTooltip =
    !HOSTING_TYPES_WITHOUT_SERVER_IMAGE_TOOLTIP.has(accountType ?? '');

  return (
    <RenderCard
      title={t('operatingSystem.title')}
      value={os}
      tooltip={
        canShowServerImageTooltip ? t('operatingSystem.tooltipv2') : undefined
      }
      tooltipIconSize={24}
      dataTestId="operating-system-card"
    />
  );
};

export default OperatingSystem;
